import { memo } from 'react';

import { buildRootUrl } from '@/common/app/utils/urlsUtils';
import { ItineraryPageItems } from '../domain/ItineraryPage.domain';
import { CommonMeta } from '@/common/ui/meta/CommonMeta';

const ItineraryPageMeta = ({ itinerary, img }: { itinerary: ItineraryPageItems; img: string }) => {
    const title = itinerary.meta.title;
    const description = itinerary.meta.description;
    const canonical = buildRootUrl(itinerary.link);

    return (
        <CommonMeta
            title={title}
            description={description}
            imageSrc={img}
            slug={canonical}
            canonical={canonical}
            noIndex
        />
    );
};

export default memo(ItineraryPageMeta);
